/**
 * @description 渠道SDK配置表格配置项
 * @param {Object} safe - vue的this对象
 * @returns {Object} option - 表格配置项
 */

export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: true,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: false,
    indexLabel: "序号",
    /** 是否启用功能按钮 */
    searchIcon: true,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 导出按钮 */
    excelBtn: false,
    /** 表格搜索按钮 */
    searchBtn: true,
    /** 表格搜索显隐按钮 */
    // searchShowBtn: true,
    /** 表格清空按钮 */
    emptyBtn: false,
    /** 开启拖拽功能 */
    // sortable: true,
    // dragHandler: true,
    // rowSort: true,
    // columnSort: true,
    menuWidth: 100,
    column: [{
        label: "ID",
        prop: "myIndex",
        slot: true
      },
      {
        label: "配置开关",
        prop: "commonTemplateId",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: false,
        // search: true,
        columnBtn: false,
        slot: true
      },
      {
        label: "策略名称",
        prop: "name",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: false
        // slot: true
        // search: true,
        /** 搜索项位置排序，序号越大越靠前 */
        // searchOrder: 1,
      },
      {
        label: "优先级",
        prop: "priority"
      },
      {
        label: "配置类型",
        prop: "appType",
        slot: true
      },
      {
        label: "渠道信息",
        prop: "appInfo",
        slot: true,
        overHidden: true
      },
      {
        label: "机型",
        prop: "model",
        hide: true
      },
      {
        label: "设备(uid)",
        prop: "uid",
        hide: true
      },
      {
        label: "用户(uuid)",
        prop: "uuid",
        hide: true
        // overHidden: true
      },
      {
        label: "版本",
        prop: "sdkVersion",
        hide: true
        // overHidden: true
      },

      {
        label: "值",
        prop: "dataText",
        overHidden: true
      },
      {
        label: "更新时间",
        prop: "updateTime"
      },
      {
        label: "审核状态",
        search: false,
        prop: "auditStatus",
        overHidden:false,
        display: false,
        type: "select",
        dicData: [{
            label: "草稿",
            value: 1
          },
          {
            label: "待审核",
            value: 2
          },
          {
            label: "审核通过",
            value: 3
          }, {
            label: "审核不通过",
            value: 4
          }
        ]
      },
      {
        label: " 操作",
        prop: "myOption",
        slot: true
      },
      {
        label: "",
        prop: "my",
        hide: true,
        showColumn: false,
        search: true,
        display: false,
        menuClassName: "myClass",
        searchslot: true
      }
    ]
  };
};
